import { render } from "../ui/app.js";

import { C } from "../core/config.js";
import { state } from "../core/state.js";
import { escapeHTML, fmtCOP, fmtDate, today } from "../core/utils.js";
import { getSaldoFactura } from "./facturas.js";

export function renderCartera() {
  const facturas = (state.data.facturas||[]).filter(f => (f.estado==="emitida"||f.estado==="vencida") && getSaldoFactura(f) > 0.01);
  const hoy = new Date(today()+"T00:00:00");

  const porCliente = {};
  facturas.forEach(f => {
    const saldo = getSaldoFactura(f);
    const venc = f.fecha_vencimiento ? new Date(f.fecha_vencimiento+"T00:00:00") : hoy;
    const diasVencido = Math.floor((hoy - venc) / (1000*60*60*24));
    const cid = f.cliente_id || "sin_cliente";
    if (!porCliente[cid]) porCliente[cid] = { cliente_id: cid, total:0, b0:0, b30:0, b60:0, b90:0, b90mas:0, facturas:[], maxDias:-Infinity };
    const grp = porCliente[cid];
    grp.total += saldo;
    grp.facturas.push({ f, saldo, diasVencido });
    grp.maxDias = Math.max(grp.maxDias, diasVencido);
    if (diasVencido <= 0) grp.b0 += saldo;
    else if (diasVencido <= 30) grp.b30 += saldo;
    else if (diasVencido <= 60) grp.b60 += saldo;
    else if (diasVencido <= 90) grp.b90 += saldo;
    else grp.b90mas += saldo;
  });

  const grupos = Object.values(porCliente).sort((a,b) => b.total - a.total);

  const totalCartera = grupos.reduce((s,g)=>s+g.total,0);
  const totalAlDia = grupos.reduce((s,g)=>s+g.b0,0);
  const totalVencido = totalCartera - totalAlDia;
  const pctVencido = totalCartera > 0 ? (totalVencido/totalCartera*100) : 0;

  const header = `
    <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:10px;flex-wrap:wrap;gap:9px;">
      <div>
        <h2 style="margin:0;font-size:17px;font-weight:800;color:#0E7490;">📊 Cartera — Cuentas por Cobrar</h2>
        <div style="font-size:11.5px;color:${C.muted};margin-top:2px;">Análisis de antigüedad de saldos por cliente, alimentado por todas las facturas</div>
      </div>
      <button onclick="exportarExcelCartera()" style="background:#16a34a;color:white;border:none;padding:8px 16px;border-radius:6px;font-weight:700;cursor:pointer;font-size:11.5px;white-space:nowrap;">📥 Exportar Excel</button>
    </div>
  `;

  if (grupos.length === 0) {
    return `
      ${header}
      <div style="padding:26px;text-align:center;background:white;border:2px dashed ${C.border};border-radius:6px;">
        <div style="font-size:40px;margin-bottom:10px;">🎉</div>
        <div style="color:${C.muted};font-size:14px;">No hay saldos pendientes por cobrar.</div>
      </div>
    `;
  }

  const kpis = `
    <div style="display:grid;grid-template-columns:repeat(auto-fit,minmax(160px,1fr));gap:9px;margin-bottom:10px;">
      <div style="background:white;border:2px solid #0E7490;border-radius:6px;padding:11px;">
        <div style="font-size:10.5px;color:${C.muted};font-weight:600;margin-bottom:4px;">TOTAL CARTERA</div>
        <div style="font-size:16px;font-weight:800;color:#0E7490;">${fmtCOP(totalCartera)}</div>
        <div style="font-size:10.5px;color:${C.muted};margin-top:4px;">${grupos.length} cliente${grupos.length!==1?"s":""}</div>
      </div>
      <div style="background:white;border:2px solid #10b981;border-radius:6px;padding:11px;">
        <div style="font-size:10.5px;color:${C.muted};font-weight:600;margin-bottom:4px;">AL DÍA</div>
        <div style="font-size:16px;font-weight:800;color:#10b981;">${fmtCOP(totalAlDia)}</div>
      </div>
      <div style="background:${pctVencido>30?"#fef2f2":"white"};border:2px solid ${pctVencido>30?"#ef4444":C.amber};border-radius:6px;padding:11px;">
        <div style="font-size:10.5px;color:${C.muted};font-weight:600;margin-bottom:4px;">VENCIDO</div>
        <div style="font-size:16px;font-weight:800;color:${pctVencido>30?"#ef4444":C.amber};">${fmtCOP(totalVencido)}</div>
        <div style="font-size:10.5px;color:${C.muted};margin-top:4px;">${pctVencido.toFixed(1)}% de la cartera</div>
      </div>
    </div>
  `;

  // Tabla de aging por cliente
  const agingHeader = `
    <tr style="background:#f8fafc;border-bottom:2px solid #0E749020;">
      <th style="padding:6px 10px;text-align:left;font-size:10.5px;color:${C.muted};font-weight:700;">CLIENTE</th>
      <th style="padding:6px 10px;text-align:right;font-size:10.5px;color:${C.muted};font-weight:700;">AL DÍA</th>
      <th style="padding:6px 10px;text-align:right;font-size:10.5px;color:${C.muted};font-weight:700;">1-30 DÍAS</th>
      <th style="padding:6px 10px;text-align:right;font-size:10.5px;color:${C.muted};font-weight:700;">31-60 DÍAS</th>
      <th style="padding:6px 10px;text-align:right;font-size:10.5px;color:${C.muted};font-weight:700;">61-90 DÍAS</th>
      <th style="padding:6px 10px;text-align:right;font-size:10.5px;color:${C.muted};font-weight:700;">+90 DÍAS</th>
      <th style="padding:6px 10px;text-align:right;font-size:10.5px;color:${C.muted};font-weight:700;">TOTAL</th>
      <th style="padding:6px 10px;text-align:center;font-size:10.5px;color:${C.muted};font-weight:700;">RIESGO</th>
      <th></th>
    </tr>
  `;

  const cell = (val) => val > 0 ? `<td style="padding:6px 10px;text-align:right;font-size:11.5px;">${fmtCOP(val)}</td>` : `<td style="padding:6px 10px;text-align:right;font-size:11.5px;color:${C.muted};">—</td>`;

  const rows = grupos.map(g => {
    const cli = state.data.clientes.find(c=>c.id===g.cliente_id) || {};
    const expanded = state.carteraExpanded && state.carteraExpanded[g.cliente_id];
    const riesgo = g.maxDias > 90
      ? `<span style="background:#fef2f218;color:#ef4444;border:1px solid #ef444440;padding:3px 9px;border-radius:20px;font-size:10.5px;font-weight:700;">🔴 Alto</span>`
      : g.maxDias > 30
        ? `<span style="background:#fffbeb18;color:${C.amber};border:1px solid ${C.amber}40;padding:3px 9px;border-radius:20px;font-size:10.5px;font-weight:700;">🟡 Medio</span>`
        : `<span style="background:#d1fae518;color:#10b981;border:1px solid #10b98140;padding:3px 9px;border-radius:20px;font-size:10.5px;font-weight:700;">🟢 Bajo</span>`;

    const detalleRows = expanded ? g.facturas.sort((a,b)=>b.diasVencido-a.diasVencido).map(({f,saldo,diasVencido}) => `
      <tr style="background:#f8fafc;border-top:1px solid ${C.border};">
        <td style="padding:6px 12px 6px 32px;font-size:11.5px;">
          <span data-action="ir-a-documento" data-tipo="FACT" data-id="${f.id}" style="color:#059669;font-weight:700;cursor:pointer;text-decoration:underline;">${escapeHTML(f.numero)}</span>
          <span style="color:${C.muted};margin-left:6px;">Vence: ${f.fecha_vencimiento?fmtDate(f.fecha_vencimiento):"—"}</span>
        </td>
        <td colspan="4"></td>
        <td style="padding:6px 12px;text-align:right;font-size:11.5px;color:${diasVencido>0?C.red:C.muted};">${diasVencido>0?`${diasVencido} días vencido`:"Al día"}</td>
        <td style="padding:6px 12px;text-align:right;font-size:11.5px;font-weight:700;">${fmtCOP(saldo)}</td>
        <td></td><td></td>
      </tr>
    `).join("") : "";

    return `
      <tr style="border-top:1px solid ${C.border};cursor:pointer;" data-action="toggle-cartera-cliente" data-id="${g.cliente_id}">
        <td style="padding:6px 10px;font-weight:700;">${expanded?"▼":"▶"} ${escapeHTML(cli.nombre||"Sin cliente")}</td>
        ${cell(g.b0)}${cell(g.b30)}${cell(g.b60)}${cell(g.b90)}${cell(g.b90mas)}
        <td style="padding:6px 10px;text-align:right;font-weight:800;color:#0E7490;">${fmtCOP(g.total)}</td>
        <td style="padding:6px 10px;text-align:center;">${riesgo}</td>
        <td></td>
      </tr>
      ${detalleRows}
    `;
  }).join("");

  return `
    ${header}
    ${kpis}
    <div style="background:white;border:1px solid ${C.border};border-radius:6px;overflow:auto;">
      <table style="width:100%;border-collapse:collapse;">
        <thead>${agingHeader}</thead>
        <tbody>${rows}</tbody>
      </table>
    </div>
    <div style="margin-top:14px;padding:9px;background:#f8fafc;border:1px solid #a5f3fc;border-radius:6px;font-size:11.5px;color:#0c4a6e;">
      💡 Haz clic en un cliente para ver el detalle de sus facturas pendientes. Las cantidades ya descuentan abonos y notas crédito.
    </div>
  `;
}

import { registerActions } from "../ui/actions.js";

registerActions({
  "toggle-cartera-cliente": (d, el, e) => {{
      if (!state.carteraExpanded) state.carteraExpanded = {};
      state.carteraExpanded[d.id] = !state.carteraExpanded[d.id];
      render();
      return;
    }},
});
